import { useMemo } from "react";
import { ListGroup } from "react-bootstrap";

import { useGetAllEcrDocTypesQuery } from "api/memberPortal/ecr/docs/ecrDocs.api";

const EcrDocumentTypeCell = ({ ecrid }: { ecrid: number | string }) => {
  const { data: docTypeList } = useGetAllEcrDocTypesQuery();

  const docs = useMemo(() => {
    if (!docTypeList) return [];

    return docTypeList.filter((docType) => docType.ecrid__ecrid === ecrid);
  }, [docTypeList, ecrid]);

  return (
    <ListGroup>
      {docs.map((docType) => (
        <ListGroup.Item key={docType.xid} disabled>
          {docType.dtid__doctype}
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
};

export default EcrDocumentTypeCell;
